import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconCornerUpRightLine.tsx
const IconCornerUpRightLine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M5 10v9h2v-7h10.172l-3.95 3.95 1.414 1.415L21 11l-6.364-6.364-1.414 1.414 3.95 3.95z"
	})]
});
var IconCornerUpRightLine_default = forwardRef(IconCornerUpRightLine);
//#endregion
export { IconCornerUpRightLine_default as default };
